import store from '../store';
import {fetchData} from "../store/coreSlice";

// A little dumb for now
export const startRefreshDaemon = () => {
	setTimeout(() => {

		tryFetch(startRefreshDaemon);
	}, 15 * 1000);
};

// This will wait until the document has focus, then fetch data, then fire the callback to restart the whole thing
const tryFetch = (cb) => {
	if( !document.hasFocus() ) {
		// Wait until they're back at the window
		// console.log("Document doesn't have focus")
		setTimeout(() => tryFetch(cb), 500);
		return;
	}

	// console.log("Auto-refreshing...");
	store.dispatch(fetchData());
	cb();
};